import React from "react";
import RowHeading from "./RowHeading";

// Represents a single ranking of a single candidate
const Choice = ({ filled, onClick }) => (
  <div
    className={`circle approval ${filled ? "filled" : ""}`}
    onClick={onClick}
  />
);

// Represents the set of possible rankings for a single candidate
const Choices = ({ rowIndex, onClick, ranking }) => (
  <td className="approvalScore">
    <Choice
      key={`approvalChoice${rowIndex}`}
      filled={!!ranking}
      onClick={() => onClick(ranking ? 0 : 1)}
    />
  </td>
);

// Represents the row of all data for a single candidate
const Row = ({
  rowIndex,
  candidate,
  bioUrl,
  party,
  choiceCount,
  ranking,
  onClick
}) => (
  <tr>
    <RowHeading candidate={candidate} party={party} bioUrl={bioUrl} />
    <Choices
      key={`approvalChoices${rowIndex}`}
      rowIndex={rowIndex}
      choiceCount={choiceCount}
      ranking={ranking}
      onClick={onClick}
    />
  </tr>
);

// Represents the list of rows corresponding to the list of candidates
const Rows = ({ choiceCount, candidates, rankings, onClick }) =>
  candidates.map((row, n) => (
    <Row
      rowIndex={n}
      key={`approvalRow${n}`}
      candidate={row.candidate}
      bioUrl={row.bioUrl}
      party={row.party}
      choiceCount={choiceCount}
      ranking={rankings[n]}
      onClick={ranking => onClick(n, ranking)}
    />
  ));

// Renders a complete RCV ballot for a single race
export default function ApprovalBallotView({
  race,
  candidates,
  rankings,
  onClick,
  readonly
}) {
  return (
    <div className={`ballot ${readonly ? "noHover" : ""}`}>
      <table>
        <thead>
          <tr>
            <td colSpan="7" className="title">
              {race}
            </td>
          </tr>
          <tr>
            <th colSpan="7" className="instructions approval">
              <p>
                Vote for one or more candidates
                <br />
                The candidate with the most votes wins
              </p>
            </th>
          </tr>
        </thead>
        <tbody>
          <Rows candidates={candidates} rankings={rankings} onClick={onClick} />
        </tbody>
      </table>
    </div>
  );
}
